<template>
	<el-form :model="form" label-width="105px" class="form">
		<div class="subTit"><i class="el-icon-caret-bottom" />展会介绍</div>
		<div class="center">
			<el-form-item label="展会介绍">
				<tinyMce :content="form.content1" v-model="form.content1" :change.sync="form.content1" />
				<!-- <vue-tinymce v-model="form.content"  :change.sync="form.content" /> -->
			</el-form-item>
			<el-form-item label="展会优势">
				<tinyMce :content="form.content2" v-model="form.content2" :change.sync="form.content2" />
				<!-- <vue-tinymce v-model="form.content"  :change.sync="form.content" /> -->
			</el-form-item>
			<el-form-item label="合作渠道">
				<tinyMce :content="form.content3" v-model="form.content3" :change.sync="form.content3" />
				<!-- <vue-tinymce v-model="form.content"  :change.sync="form.content" /> -->
			</el-form-item>
		</div>
		<div class="submit-btn" @click="handleSubmit">保存</div>
	</el-form>
</template>

<script>
	import {
		setting,
		setup
	} from '@/assets/js/tinymceSt.js'
	import tinyMce from '@/components/plug/tinyMce'
	export default {
		data() {
			return {
				exhibition_id: '',
				form: {
					content1: '',
					content2: '',
					content3: '',
				},
				forms: {

				},
				content: [{
					validator: (rule, value, callback) => {
						if (this.form.content === '') {
							callback(new Error('请输入详细内容'));
						} else {
							callback();
						}
					}
				}],
			}
		},
		beforeCreate() {

		},
		created() {
			if (this.$route.query.id > 0) {
				this.exhibition_id = this.$route.query.id
				this.getdata()
			}
		},
		methods: {
			getdata() {
				this.$axios.post('Exhibition-Admin-getExhibitionShopInfo', {
					exhibition_id: this.exhibition_id
				}).then(data => {
					let datas = data.jieshao
					this.form.content1 = datas[0]
					this.form.content2 = datas[1]
					this.form.content3 = datas[2]
				})
			},
			handleSubmit() {
				let datas = []
				datas[0] = this.form.content1
				datas[1] = this.form.content2
				datas[2] = this.form.content3
				this.forms.exhibition_id = this.$route.query.id
				this.forms.jieshao = datas
				this.forms.user_id = this.$store.state.USER_ID
				this.$emit("eventForm", this.forms)
			}
		},
		components: {
			tinyMce
		}
	}
</script>

<style scoped>
	.form>>>.el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.tishinews {
		color: #666ee8;
	}
</style>
